import type { DropDownListChangeEvent } from "@tql/ui-components-react/kendo/dropdowns";
import type { GridFilterCellProps } from "@tql/ui-components-react/kendo/grid";
import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";

type Item = { text: string; value: boolean | null };
const ALL_ITEM: Item = { text: "All", value: null };
const items: Item[] = [
	ALL_ITEM,
	{ text: "On", value: true },
	{ text: "Off", value: false },
];

/**
 * Filter cell for the boolean `canAutoDispatch` column. Replaces Kendo's
 * default boolean filter (which displays `(All)` and gets clipped in narrow
 * columns) with an explicit Yes/No/All dropdown.
 */
export const AutoDispatchFilterCell = (props: GridFilterCellProps) => {
	const selected = items.find((item) => item.value === props.value) ?? ALL_ITEM;

	const handleChange = (event: DropDownListChangeEvent) => {
		const item = event.value as Item;
		const isCleared = item.value === null;
		props.onChange({
			value: isCleared ? null : item.value,
			operator: isCleared ? "" : "eq",
			syntheticEvent: event.syntheticEvent,
		});
	};

	return (
		// Mirror Kendo's default filter cell wrappers so the TraxGrid
		// search-icon injector and filter-tab navigation hooks keep working.
		<div className={"k-filtercell"}>
			<div className={"k-filtercell-wrapper"}>
				<DropDownList
					aria-label={"Filter auto dispatch"}
					data={items}
					dataItemKey={"text"}
					onChange={handleChange}
					textField={"text"}
					value={selected}
				/>
			</div>
		</div>
	);
};
